import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { result } from 'underscore';

@Injectable({ providedIn: 'root' })
export class ClientTimeclockService {
  constructor(
    private httpClient: HttpClient,
    @Inject('env') private env: any
  ) {}

  public validateConfig(clientCode: string, timekeepingId: string) {
    return this.httpClient
      .post<{ Value: boolean }>(`${this.env.apiUrlRoot}/ClientTimeclock/${clientCode}/validate`, {
        ServiceId: 1,
        TimekeepingId: timekeepingId
      })
      .pipe(map(result => result.Value));
  }

  public validateSiteId(clientCode: string, siteId: number) {
    return this.httpClient
      .post<{ Value: boolean }>(
        `${this.env.apiUrlRoot}/ClientTimeclock/${clientCode}/validateSiteId`,
        {
          SiteId: siteId
        }
      )
      .pipe(map(result => result.Value));
  }

  public openPortal(clientCode: string) {
    return this.httpClient
      .get<{ Value: string }>(`${this.env.apiUrlRoot}/ClientTimeclock/${clientCode}/OpenPortal`)
      .pipe(map(result => result.Value));
  }
}
